<template>
  {{ cartData.item_count || ""
  }}<template v-if="cartData.item_count"><slot></slot></template>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "CartCount",

  computed: {
    ...mapState("cart", ["cartData"]),
  },
};
</script>
